<div class="container mx-auto container-base">
    <div class="hero-text" style="margin-left: 10px;">
        <h1 style="font-weight: 800;">{{'CONTAINER'|translate}}</h1>
    </div>
    <div style="overflow: auto;">
        <div class="p-20" style="min-width: 1200px;">
            <mat-table style="border-radius: 10px 10px 0px 0px;" #table [dataSource]="dataSource"
                matSort [@animateStagger]="{value:'50'}"  fusePerfectScrollbar>

                <ng-container matColumnDef="deviceId">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DEVICE'|translate}} {{'ID'|translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let container">
                        {{container?.deviceId!=null?(container?.deviceId):'---'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="neighbor">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'NEIGHBOURHOOD'|translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let container">
                        {{container?.neighbor!=null?container.neighbor:'---'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="street">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'STREET'|translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let container">
                        {{container?.street!=null?container.street:'---'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="streetDesc">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'ADDRESS'|translate}}</mat-header-cell>
                    <mat-cell *matCellDef="let container">
                        {{container?.streetDesc!=null?container.streetDesc:'---'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="device.deviceLatestStatus.batarya">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'BATTERY'|translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let container">
                        {{container.device?.deviceLatestStatus?.batarya!=null?(container.device?.deviceLatestStatus.batarya):'---'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="device.deviceLatestStatus.mesafe">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'OCCUPANCY'|translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let container">
                        {{container.device?.deviceLatestStatus?.mesafe!=null?(container.device?.deviceLatestStatus.mesafe | containerMsf:container.altitude : container.deadZone  | number : '1.2-2'):'---'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="device.deviceLatestStatus.sonBaglantiTarih">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DATE'|translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let container">
                        {{container.device?.deviceLatestStatus?.sonBaglantiTarih!=null?(container?.device.deviceLatestStatus.sonBaglantiTarih | date:"dd/MM/y HH:mm"):'---'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="setting">
                    <mat-header-cell *matHeaderCellDef>{{'SETTINGS'|translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let container">
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                            <mat-icon>settings</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="onContainerMap(container)">
                                <mat-icon>maps</mat-icon>
                                <span>{{'MAPS'|translate}}</span>
                            </button>
                        </mat-menu>
                    </mat-cell>
                </ng-container> 
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                <mat-row *matRowDef="let container; columns: displayedColumns;" matRipple>
                </mat-row>
            </mat-table>
            
            <mat-paginator #paginatorGeneric [length]="paginatorGeneric.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>